import { render, staticRenderFns } from "./MatchdayWinner.vue?vue&type=template&id=cd07179c"
import script from "./MatchdayWinner.vue?vue&type=script&lang=js"
export * from "./MatchdayWinner.vue?vue&type=script&lang=js"
import style0 from "./MatchdayWinner.vue?vue&type=style&index=0&id=cd07179c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports